import { faker } from '@faker-js/faker';

/**
 * Generates fake patient data for test cases
 * @returns {object} Generated patient data
 */
export const generatePatientData = () => ({
  firstName: faker.person.firstName(),
  lastName: faker.person.lastName(),
  dob: faker.date.birthdate({ mode: 'age', min: 18, max: 65 }).toISOString().split('T')[0],
  gender: faker.helpers.arrayElement(['Male', 'Female', 'Other']),
  postalCode: faker.location.zipCode('#####'),
  mrn: faker.string.uuid(),
  umrn: faker.string.uuid(),
  pronoun: faker.helpers.arrayElement(['He/Him', 'She/Her', 'They/Them']),
  conversationStyle: faker.helpers.arrayElement(['formal', 'casual', 'informal']),
  patientId: faker.string.uuid(),
  externalId: faker.string.uuid(),
});
